export default __webpack_public_path__ + "assets/images/aistudio/b2df22042c78db40640efcc66aad52ab.png";